import { render, staticRenderFns } from "./ElEntityInput.vue?vue&type=template&id=b2c465bc"
import script from "./ElEntityInput.vue?vue&type=script&lang=js"
export * from "./ElEntityInput.vue?vue&type=script&lang=js"
import style0 from "./ElEntityInput.vue?vue&type=style&index=0&id=b2c465bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports